export default {
  title: 'Relatórios',
  icon: 'GraphUp',
  iconPack: 'bootstrap',
  children: [
    {
      title: 'Vendas por Meio de Pagamento',
      route: 'report-sale-by-payment-method',
      resource: 'SaleReports',
      action: 'SaleByPaymentMethod',
    },
    {
      title: 'Vendas por Produto',
      route: 'report-sku-sale-detailed',
      resource: 'SaleReports',
      action: 'SkuSaleDetailed',
    },
    {
      title: 'Vendas Parceladas',
      route: 'report-installment-sales',
      resource: 'SaleReports',
      action: 'InstallmentSales',
    },

    {
      title: 'Entregas por Motoboy',
      route: 'report-motoboy-deliveries',
      resource: 'DeliveryReports',
      action: 'MotoboyDeliveries',
    },
    {
      title: 'Contas a Pagar',
      route: 'report-accounts-payable',
      resource: 'FinancialReports',
      action: 'AccountsPayable',
    },
    {
      title: 'Contas a Receber',
      route: 'report-receivables',
      resource: 'FinancialReports',
      action: 'Receivables',
    },
    {
      title: 'Conta Corrente',
      route: 'report-checking-account-statement',
      resource: 'FinancialReports',
      action: 'CheckingAccountStatement',
    },
    {
      title: 'Conciliação - Transações Ignoradas',
      route: 'reconciliation-peding-itens-list',
      // resource: 'auth',
      // action: 'Read',
    },
  ],
}
